import { annotatorClient } from './annotatorClient';
import type { AnnotatorImageItem, AnnotatorImagePage } from '../types/annotator';

export async function listImages(
  projectId: number,
  annotated?: boolean,
  page = 1,
  pageSize = 60,
  labelId?: number,
  isVerified?: boolean,
): Promise<AnnotatorImagePage> {
  const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
  if (annotated !== undefined) params.set('annotated', String(annotated));
  if (labelId !== undefined) params.set('label_id', String(labelId));
  if (isVerified !== undefined) params.set('is_verified', String(isVerified));
  return annotatorClient.get<AnnotatorImagePage>(`/projects/${projectId}/images/?${params}`);
}

export async function getImage(projectId: number, imageId: number): Promise<AnnotatorImageItem> {
  return annotatorClient.get<AnnotatorImageItem>(`/projects/${projectId}/images/${imageId}`);
}

export async function uploadImages(projectId: number, files: File[]): Promise<AnnotatorImageItem[]> {
  const form = new FormData();
  files.forEach((f) => form.append('files', f));
  return annotatorClient.postForm<AnnotatorImageItem[]>(`/projects/${projectId}/images/upload`, form);
}

export async function getImageFile(projectId: number, imageId: number): Promise<string> {
  return annotatorClient.getBlob(`/projects/${projectId}/images/${imageId}/file`);
}

export async function getImageThumbnail(projectId: number, imageId: number): Promise<string> {
  return annotatorClient.getBlob(`/projects/${projectId}/images/${imageId}/thumbnail`);
}

export async function deleteImage(projectId: number, imageId: number): Promise<void> {
  await annotatorClient.delete(`/projects/${projectId}/images/${imageId}`);
}

export async function verifyImage(projectId: number, imageId: number): Promise<AnnotatorImageItem> {
  return annotatorClient.post<AnnotatorImageItem>(`/projects/${projectId}/images/${imageId}/verify`);
}

export async function verifyAllImages(projectId: number): Promise<{ verified: number }> {
  return annotatorClient.post<{ verified: number }>(`/projects/${projectId}/images/verify-all`);
}


export interface ExportImagesResult {
  exported_count: number;
  skipped_count: number;
}

export async function exportImagesToProject(
  projectId: number,
  imageIds: number[],
  destProjectId: number,
  removeFromSource: boolean,
): Promise<ExportImagesResult> {
  return annotatorClient.post<ExportImagesResult>(
    `/projects/${projectId}/images/export-to-project`,
    { image_ids: imageIds, dest_project_id: destProjectId, remove_from_source: removeFromSource },
  );
}

export async function deleteAllImages(projectId: number, isVerified?: boolean): Promise<void> {
  const ids: number[] = [];
  let page = 1;
  let pages = 1;
  do {
    const result = await listImages(projectId, undefined, page, 200, undefined, isVerified);
    result.items.forEach((img) => ids.push(img.id));
    pages = result.pages;
    page++;
  } while (page <= pages);
  await Promise.all(ids.map((id) => annotatorClient.delete(`/projects/${projectId}/images/${id}`)));
}
